import React from "react";
import "./LeftTopDashBoard.css";
import profile1 from "../../images/profile1.jpg";
import { useState, useCallback, useEffect } from "react";
import {
  csv,
  arc,
  pie,
  scaleBand,
  scaleLinear,
  max,
  format,
  tickFormat,
} from "d3";
import BarIcon from "../Icons/BarIcon";
import StarIcon from "../Icons/StarIcon";
import BlueTick from "../Icons/BlueTick";

const csvUrl =
  "https://gist.githubusercontent.com/VasumathiArichandran/23c5f408096599f03c324222d24c7e5e/raw/78e8f8941280dfb28894d50a03ce066da7eda404/ProgressBar.csv";
const width = 330;
const height = 42;
const margin = { top: 0, right: 80, bottom: 0, left: 0 };
export default function LeftTopDashBoard() {
  var [data, setData] = useState(null);
  useEffect(() => {
    var row = (d) => {
      d.Population = +d["2050"];
      d.Population1 = +d["2025"];
      return d;
    };
    csv(csvUrl, row).then(setData);
  }, []);

  if (!data) {
    return <pre>Loading...</pre>;
  }
  const innerHeight = height - margin.top - margin.bottom;
  const innerWidth = width - margin.left - margin.right;

  console.log(data[15]);

  // data = data.sort(function(a, b) {
  //   return a.Population - b.Population1
  // });

  //scale axis based on data
  // xScale.domain(data.map(d => d.name));

  //xScale0.domain(models.map(d => d.model_name))
  // xScale1.domain(["field1", "field2"]).range([0, xScale0.bandwidth()]);
  // yScale.domain([
  //   0,
  //   d3.max(models, (d) => (d.field1 > d.field2 ? d.field1 : d.field2)),
  // ]);

  const yScale = scaleBand()
    .domain(data.map((d) => d["Country or area"]))
    .range([0, height]);
  // .padding(0);

  const yScale1 = scaleBand();

  yScale1.domain(["Population", "Population1"]).range([0, yScale.bandwidth()]);

  const xScale = scaleLinear()
    .domain([0, max(data, (d) => d.Population)])
    .range([0, innerWidth]);

  console.log(xScale.ticks());

  return (
    <>
      <div className="LeftTopDashBoard">
        <div className="LeftTopDashBoardHeading">
          <p className="LeftTopDashBoardHeading1">Top Merchant</p>
          <p className="LeftTopDashBoardHeading2">List merchant</p>
        </div>
        <div className="profile-1">
          <img src={profile1} className="profile-photo"></img>
          <div className="profile-name-details">
            <p className="profile-name"> Summer Mini Bars</p>
            <div className="profile-extra-details">
              <p className="profile-city">Outlet terjual</p>
              <p className="profile-comments">(24)</p>
              <StarIcon />
              <p className="profile-rating">5</p>
            </div>
          </div>
          <BlueTick />
        </div>
        <svg width={width} height={height - 30} className="Progress-Bar">
          {/* <g transform={`translate(${margin.left},${margin.top})`}> */}
          <g>
            {" "}
            {/* {xScale.ticks().map((tickValue) => (
              <g
                key={tickValue}
                transform={`translate(${xScale(tickValue)},0)`}
              >
                <line y2={innerHeight} stroke="#c0c0bb" />
                <text
                  className="xScaleText"
                  style={{ textAnchor: "middle", fontSize: "4px" }}
                  dy="-92.71em"
                  y={innerHeight}
                >
                 {tickFormat(tickValue)}
                  {format(".2s")(tickValue).replace("G", "B")}
                </text>
              </g>
            ))} */}
            {/* {yScale.domain().map((tickValue) => (
              <text
                key={tickValue}
                className="xScaleText"
                style={{ textAnchor: "end", fontSize: "4px" }}
                dx="-29.31em"
                x={innerWidth}
                y={yScale(tickValue) + yScale.bandwidth() / 2}
              >
                {tickValue}
              </text>
            ))} */}
            {/* <text
              x={innerWidth / 2}
              y={innerHeight}
              style={{ textAnchor: "middle", fontSize: "10px" }}
            >
              Population
            </text> */}
            {data.map((d) => (
              <>
                <rect
                  className="mark"
                  key={d["Country or area"]}
                  x={0}
                  y={yScale(d["Country or area"])}
                  width={xScale(d.Population)}
                  height={yScale1.bandwidth()}
                />
                <rect
                  className="mark1"
                  key={d["Country or area"]}
                  x={0}
                  y={yScale(d["Country or area"])}
                  width={xScale(d.Population1)}
                  height={yScale1.bandwidth()}
                />
              </>
            ))}
          </g>
        </svg>
        <div className="point-details">
          <div className="point-details-1">
            <svg width={20} height={33}>
              <circle className="progress-bar-1" cx={8} cy={7} r={6} />
            </svg>
            <div>
              <p className="point-details-amount-1">$356,000,00</p>
              <p className="net-profit">Net Profit per month</p>
            </div>
          </div>
          <div className="point-details-2">
            <svg width={20} height={33}>
              <circle className="progress-bar-2" cx={8} cy={7} r={6} />
            </svg>
            <div>
              <p className="point-details-amount-2">$216,000,00</p>
              <p className="gross-profit">Gross Profit per month</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
